

import React, { useState } from 'react';

import Typography from '@mui/material/Typography'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import Link from '@mui/material/Link'
import { Button, Grid } from '@mui/material'

import filterIcon from './../../../../assets/icons/filter 1.png'
import searchIcon from './../../../../assets/icons/searchIcon 1.png'
import AddItemDialogComponent from './AddItemDialog.tsx'

import FilterComponents from '../FilterComponents.tsx';
import SectionTable from '../SectionTable.tsx';
import AddSectionDialog from '../AddSectionDialog.tsx';
import burger from './../../../../assets/icons/burger.png'
import edit from './../../../../assets/icons/edit.png'
import bin from './../../../../assets/icons/recycle-binColor.png'
import ediPencil from './../../../../assets/icons/editPencil.png'
//table
import arrowUp from './../../../../assets/icons/arrowup.png'
import arrowDown from './../../../../assets/icons/arrowDown.png'
import Paper from '@mui/material/Paper';

import Box from '@mui/material/Box'
import Tab from '@mui/material/Tab'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import SectionItemsDialog from '../SectionItemsDialog/SectionItemsDialog.tsx';
//table end
import './AddSubSection.css'
import CustomDataGrid from '../../../components/CustomDataGrid/CustomDataGrid.tsx';
import editImg from './../../../../assets/icons/edit.png'
import axios from 'axios';


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import EditSection from '../EditSection/EditSection.tsx';
import LoadingView from '../../../components/LoadingView/LoadingView';


//table start
interface Column {
  id: 'checkBox' | 'sectionid' | 'sectionname' | 'foodname';
  label: string;
  minWidth?: number;
  align?: 'right';
  format?: (value: number) => string;
}

const columns: readonly Column[] = [
  { id: 'checkBox', label: 'Check', minWidth: 100 },
  { id: 'sectionid', label: 'Id', minWidth: 100 },
  { id: 'sectionname', label: 'Name', minWidth: 100 },

  {
    id: 'foodname',
    label: 'Icon',
    minWidth: 100,
    align: 'left',

  },


];



function createData(
  sectionid: string,
  sectionname: string,



) {

  return { sectionid, sectionname };
}

const rows = [
  createData('B10101', 'Standard', false),
  createData('B10101', 'Special', false),
  createData('B10101', 'Shop', false),
  createData('B10101', 'Set menu', false)
];


//table end

function AddSubSection(props) {

  const [selectedData, setSelectedData] = useState({})


  const [openAddSection, setOpenAddSection] = useState(false);
  const [openSection, setopenSection] = useState(false);
  const [openEditSection, setOpenEditSection] = useState(false);
  const [dialogType, setDialogType] = useState('');

  const handleAddSectionDialogData = (data) => {

    setSelectedData(data);
    setLoading(true);
    setDataRows([]);
    setSectionDialogOpen(false)
    loadMenuData();
    loadData(selectedMenu)
  }

  const handleClickOpen = () => {
    setOpenAddSection(true);
    setDialogType('add');
  }

  const handleAddItem = (AddSectionData) => {
    loadData(selectedMenu)
    setOpenAddSection(AddSectionData)
    //loadData(selectedMenu)

  }

  const handleSectionOpen = (AddSectionData) => {
    setopenSection(false)
    //loadData(selectedMenu)

  }
  const handleEditItem = (AddSectionData) => {
    setOpenEditSection(AddSectionData);
    loadData(selectedMenu);
  }
  //table start

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  //table end
  const [value, setValue] = React.useState('1')

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue)
  }

  const [sectionItemsToggle, setsectionItemsToggle] = React.useState(false);
  const [sectionItemsdialogType, setsectionItemsdialogType] = React.useState("");
  const onHandlesectionItems = () => {
    setsectionItemsToggle(false);
  }
  const rows = [
    createData('B10101', 'Standard', false),
    createData('B10102', 'Special', false),
    createData('B10103', 'Shop', false),
    createData('B10104', 'Set menu', false)
  ];



  const [selectedSections, setSelectedSections] = React.useState([]);
  const [tempselectedSections, settempSelectedSections] = React.useState([]);
  const [countSelectedDatas, setcountSelectedDatas] = React.useState(0);
  React.useEffect(() => {
    setSelectedSections(tempselectedSections);

  }, [selectedSections])
  const handleCheckChange = (props) => {
    console.log("props: " + props.sectionid);
    var temp = selectedSections;
    var count = selectedSections.length;
    var val = selectedSections.find(x => x.sectionid == props.sectionid);
    console.log("val: " + val);
    if (val != undefined) {
      var index = selectedSections.indexOf(val);
      console.log("temp.indexOf(val): " + index);
      temp = selectedSections.slice(index, 1);
      count -= 1;
    }
    else {
      temp.push(props);
      count += 1;
    }
    settempSelectedSections(temp);
    console.log("temp: " + temp);
    setSelectedSections([]);
    console.log("selectedSections: " + selectedSections);
    setcountSelectedDatas(count)
  }
  const [Loading, setLoading] = React.useState(false);
  const changeOrderByTextBox = (props, type) => {
    console.log(props.target.value);
    console.log(type);

    if (props.target.value != "") {
      setLoading(true);
      if (lastRank - 1 < props.target.value) {
        setLoading(false);
        toast.error("please select a valid number", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
      else {
        axios
          .put(apiAddress + "/api/SubSection/updaterankwithtextboxsection?id=" + type.id + "&newRank=" + props.target.value)
          .then((response) => {
            console.log(response.data);
            setDataRows([]);
            toast.success("Successfully updated", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            loadData(selectedMenu);
          });
      }

    }
  }
  const [sectionNameItemsdialogType, setsectionNameItemsdialogType] = React.useState("");
  const columnsdatas = [
    {
      field: 'displayOrder',
      headerName: 'Display Order',
      renderCell: (params) =>
        <div className='d-flex align-items-center' style={{ gap: "10px" }}>
          <span className={`${params.row.displayOrder == 1 ? 'deselct' : ""}`} style={{ cursor: "pointer" }} onClick={() => { changeOrder(params.row, 2) }} >
            <img src={arrowUp} style={{ width: "1rem" }} />
          </span>
          <input type='number' className='form-control' style={{ width: "7rem" }} defaultValue={params.value} onChange={(event) => { changeOrderByTextBox(event, params.row) }} />
          <span className={`${params.row.displayOrder == lastRank - 1 ? 'deselct' : ""}`} style={{ cursor: "pointer" }} onClick={() => { changeOrder(params.row, 1) }} >
            <img src={arrowDown} style={{ width: "1rem" }} />
          </span>
        </div>,
      align: 'center',
      headerAlign: 'center',
      width: 200,
    },
    {
      field: 'name', headerName: 'Name', renderCell: (params) =>
        <div className='d-flex ' style={{ gap: "10px" }}>
          <span onClick={() => { setsectionItemsToggle(true); setsectionItemsdialogType(params.row.id); setsectionNameItemsdialogType(params.value) }} style={{ color: "blue", cursor: "pointer" }}>{params.value}</span>
          <div style={{ color: "blue", cursor: "pointer" }} onClick={() => { onEditClick(params.row.id) }}>
            <img src={ediPencil} alt="" style={{ width: "1rem" }} />
          </div>
        </div>, align: 'center', headerAlign: 'center', flex: 1
    },
    {
      field: 'icon',
      headerName: 'Icon',
      renderCell: (params) => <img src={params.value} alt='burger' style={{ width: '2rem', height: '2rem' }} />, align: 'center', headerAlign: 'center', flex: 1
    },

  ];

  const changeOrder = (props, type) => {
    console.log(props);
    console.log(type);
    setLoading(true);
    axios
      .put(apiAddress + "/api/SubSection/updateranksection?id=" + props.id + "&status=" + type)
      .then((response) => {
        console.log(response.data);
        setDataRows([]);
        toast.success("Successfully updated", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });

        loadData(selectedMenu);
      });
  }


  const [dataRows, setDataRows] = useState([])

  React.useEffect(() => {

    loadMenuData();
    loadAllMenu();
  }, [])
  const apiAddress = process.env.REACT_APP_SECRET;
  const [dataCollection, setDataCollection] = useState([]);
  const [lastRank, setLastRank] = useState(1);
  const loadData = (props) => {
    if (props != undefined) {
      console.log(props);
      setLastRank(1)

      axios
        .get(apiAddress + "/api/SubSection/getallsubsectionbymenuid?id=" + props.id)
        .then((response) => {
          console.log(response.data);
          var list = [];
          var collectionList = response.data;
          setDataCollection(collectionList);
          response.data.map((dt, i) => {
            var obj = { id: dt.id, displayOrder: dt.rank, name: dt.keywordName, icon: dt.iconUrl, type: dt.sectionTypeId }
            list.push(obj);
          })
          console.log(list);

          if (list.length > 0) {
            setDataRows(list);
            var rank = (list[list.length - 1].displayOrder)
            setLastRank(rank + 1)
          }


          setLoading(false);
        });
    }

  }
  const [selectedDataRows, setSelectedDatarows] = React.useState([]);
  const [selectedDataRowsCount, setSelectedDatarowsCount] = React.useState([]);




  const getselectedData = (props) => {
    console.log(props);
    // setSelectedDatarows(props)
    console.log(selectedDataRows[value])
    if (selectedDataRows[value] === undefined) {
      selectedDataRows[value] = [];
      selectedDataRowsCount[value] = [];
    }
    selectedDataRows[value] = props;
    selectedDataRowsCount[value] = props.length;
    setSelectedDatarowsCount(selectedDataRowsCount);
    console.log("selectedDataRows[value]: " + selectedDataRows[value]);
    setSelectedDatarows(selectedDataRows);
    setcountSelectedDatas(props.length);
  }
  console.log(selectedDataRows)
  const TabWithCount = ({ children, count }) => {
    console.log("count: " + count);
    console.log("value: " + value);
    return (
      <div >
        {
          selectedDataRowsCount[count] > 0 ?
            <div className='d-flex align-items-center' style={{ gap: "10px" }}>
              <span>{children}</span> <div className='roundedSelectionCorner'> {selectedDataRowsCount[count]} items selected</div>
            </div> : <span>{children}</span>
        }

      </div>
    );
  };
  const deleteBin = () => {
    var valid = true;
    console.log(selectedDataRows);
    if (selectedDataRows[value] == undefined) {
      valid = false;
      toast.error("please select any sub section", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    else {
      axios
        .put(apiAddress + "/api/SubSection/deletesection?status=0", selectedDataRows[value])
        .then((response) => {
          console.log(response.data);
          setDataRows([]);
          loadData(selectedMenu)
        });
    }

  }

  const [selectedDataForEdit, setSelectedDataForEdit] = useState();

  const onEditClick = (props) => {
    console.log(props);
    var obj = dataCollection.find(x => x.id == props);
    console.log(obj);
    setSelectedDataForEdit(obj);
    setOpenEditSection(true);
  }
  const [tabViewItemList, settabViewItemList] = React.useState([]);

  const loadMenuData = () => {
    const restaurant = localStorage.getItem('restaurant');
    var res = JSON.parse(restaurant);
    console.log(res);
    axios
      .get(apiAddress + "/api/Section/getallsectionbyrestaurantid?restaurantId=" + res.id)
      .then((response) => {
        console.log(response.data);
        settabViewItemList(response.data)
        if (response.data.length > 0) {
          loadData(response.data[0]);
        }

      });
  }
  const [menuList, setMenuList] = useState([])
  const loadAllMenu = () => {
    axios
      .get(apiAddress + "/api/Menu/GetAllMenuIconListAsync")
      .then((response) => {
        console.log(response.data);
        if (response.data.length > 0) {
          var list = []
          response.data.map((dt, i) => {
            var obj = { id: dt.id, title: dt.menuName }
            list.push(obj)
          })
          setMenuList(list);
          // settabViewItemList(response.data)
          loadData(response.data[0]);
          // setselectedMenu(response.data[0]);
        }

      });
  }
  console.log(menuList)
  const [selectedMenu, setselectedMenu] = useState();

  const onTabClick = (data) => {
    setselectedMenu(data);
    setDataRows([]);
    loadData(data)
  }

  const TabViewItem = ({ children, count, data }) => {

    return (
      <div onClick={() => { onTabClick(data) }}>
        {
          <div>
            {children}
          </div>
        }

      </div>
    );
  }
  const [openAddMenu, setopenAddMenu] = useState(false);
  // const handleClickAddMenuOpen = () => {
  //   setopenAddMenu(true);

  // }
  const [sectionDialogOpen, setSectionDialogOpen] = useState(false)
  const handleClickSectionDialogOpen = () => {
    setSectionDialogOpen(true)
  }
  const handleSectionDialogClose = (props) => {
    setLoading(true);
    setDataRows([]);
    setSectionDialogOpen(props)
    loadMenuData();
    loadData(selectedMenu)
  }
  const handleAddMenu = (AddSectionData) => {
    setopenAddMenu(false);
    loadMenuData();
  }
  return (
    <div>
      <ToastContainer />
      <LoadingView open={Loading} close={() => { setLoading(false) }} />
      <AddSectionDialog open={sectionDialogOpen} onHandleAddItem={handleSectionDialogClose} onHandleSelectedData={handleAddSectionDialogData} menuList={menuList} />
      {tabViewItemList.length > 0 ? (
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleChange} aria-label="lab API tabs example" variant="scrollable"
              scrollButtons="auto">
              {
                tabViewItemList.map((dt, i) => {
                  return (
                    // <Tab label={dt.menuName} value={i} />
                    <Tab label={<TabViewItem count={i} data={dt}>{dt.keywordName}</TabViewItem>} value={i} />
                  )

                })
              }
              {/* <Tab label={<TabWithCount count={3}>Btn</TabWithCount>} value={tabViewItemList.length} /> */}
              <div className='mt-1'>
                <button className='btn btnAddNew' onClick={() => { setopenSection(true) }}>+ Add new</button>
              </div>

              {/* <Tab label="In Store Menu" value="2" />
                            <Tab label="Offers" value="3" /> */}
            </TabList>
          </Box>

          {
            tabViewItemList.map((dt, i) => {
              return (
                // <Tab label={dt.menuName} value={i} />
                value == i ? (
                  <>
                    <Grid
                      container
                      alignItems="center"
                      justifyContent="space-between"
                      mt={2}
                      mb={2}
                    >
                      <Grid item>
                        <Grid container spacing={2} alignItems="center">
                          <Grid item>
                            <Button
                              color="primary"
                              size="medium"
                              variant="contained"
                              style={{ borderRadius: '50%', minWidth: 'auto' }}
                              onClick={handleClickOpen}
                            >
                              +
                            </Button>
                          </Grid>
                          <Grid item>
                            <img src={filterIcon} alt="" style={{ width: '1rem' }} />
                          </Grid>
                          <Grid item>Add Filter</Grid>

                          <Grid item>
                            <div className='roundedCorner'>
                              <img src={bin} alt="" style={{ width: '1rem' }} onClick={() => { deleteBin() }} />
                            </div>
                          </Grid>
                          <Grid item>

                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item>
                        <Grid container flexDirection={'column'} alignItems={'center'}>
                          <Grid item>
                            <img src={searchIcon} alt="" style={{ width: '1rem' }} />
                          </Grid>
                          <Grid item>Search</Grid>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Paper sx={{ width: '100%', overflow: 'hidden' }}>

                      {
                        dataRows.length > 0 ? (
                          selectedDataRows[value] != undefined ? <CustomDataGrid columns={columnsdatas} dataRows={dataRows} getselectedData={getselectedData} selectedRows={selectedDataRows[value]} isLoading={Loading} /> : <CustomDataGrid columns={columnsdatas} dataRows={dataRows} getselectedData={getselectedData} />
                        ) : ("No Data found")

                      }

                    </Paper>
                  </>
                ) : ""
              )

            })
          }

        </TabContext>
      ) :
        <div className='mt-1'>
          <button className='btn btnAddNew' onClick={() => { setopenSection(true) }}>+ Add new</button>
        </div>}


      {
        openAddSection ? (
          <AddSectionDialog open={openAddSection}
            dialogType={'Add Sub Section'} onHandleAddItem={handleAddItem} onHandleSelectedData={handleAddSectionDialogData} lastRank={lastRank} />
        ) : ""
      }
      {
        openSection ? (
          <AddSectionDialog open={openSection}
            dialogType={'Add Section'} from={'sub section'} onHandleAddItem={handleSectionOpen} onHandleSelectedData={handleAddSectionDialogData} lastRank={lastRank} />
        ) : ""
      }
      {
        openEditSection ? (
          <EditSection open={openEditSection}
            dialogType={'Add Sub Section'} onHandleAddItem={handleEditItem} selectedDataForEdit={selectedDataForEdit} />
        ) : ("")
      }
      {
        sectionItemsToggle ? (
          <SectionItemsDialog open={sectionItemsToggle} dialogType={sectionItemsdialogType} onHandleAddItem={onHandlesectionItems} sectionName={sectionNameItemsdialogType} type={2} />
        ) : ("")
      }

    </div>
  );
}

export default AddSubSection; 